'use client';
import React from 'react';

import CalendarEventContainer from './CalendarEventContainer';
import { useGetCalendarEvent } from '../../../../hooks/event/use-get-calendar-event.hook';
import { CALENDAR_DAYS } from '@wwe-portal/web/utils/calendar/contant';

function CalendarEvents() {
  const { eventsTypes } = useGetCalendarEvent();

  return (
    <div
      id="calendarEvents"
      className="calendar__events scroll-smooth"
      style={{ height: 'calc(100dvh - 400px)' }}
    >
      <CalendarEventContainer
        eventsDay={CALENDAR_DAYS.today.id}
        events={eventsTypes.today}
        type={CALENDAR_DAYS.today.key}
      />
      <CalendarEventContainer
        eventsDay={CALENDAR_DAYS.tomorrow.id}
        events={eventsTypes.tomorrow}
        type={CALENDAR_DAYS.tomorrow.key}
      />
      <CalendarEventContainer
        eventsDay={CALENDAR_DAYS.thisWeek.id}
        events={eventsTypes.thisWeek}
        type={CALENDAR_DAYS.thisWeek.key}
      />
      <CalendarEventContainer
        eventsDay={CALENDAR_DAYS.nextWeek.id}
        events={eventsTypes.nextWeek}
        type={CALENDAR_DAYS.nextWeek.key}
      />
    </div>
  );
}

export default CalendarEvents;
